import ApiService from "../../../common/api.service";
import { dataList } from './mock'

export async function GetPushcartProducts({ commit }) { //, option
  try {
    ApiService.init("heroku");
    commit("PUSHCART_PRODUCT_REQUEST");
    ApiService.setHeader();
    // const _response = await ApiService.query("/v1/onboard", option);
    commit("PUSHCART_PRODUCT_SUCCESS", dataList);
  } catch (error) {
    commit("PUSHCART_PRODUCT_ERROR", { result: error.message });
  }
}
